/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

export const mapBreadcrumb = c => ({
    __typename: 'CategoryTree',
    identifier: c.category_uid ? c.category_uid : c.category_id.toString(),
    name: c.category_name,
    url_key: c.category_url_key
});

export const typeNameToText = typeName => typeName.replace(/([a-z])([A-Z])/g, '$1 $2');
